import { ContentType } from '@generalTypes/apiTypes';
import { selectKrcCurriculumNode } from '@newStore/documentUI/transformContent/krcContentNodeSelectors';
import { getAllOfResource } from '@newStore/externalData/externalDataState';
import { pathMap } from '@newStore/externalData/externalDataTypes';
import { referenceFrames } from '@newStore/referenceFrames/referenceFrames';
import { loadReferenceFrame } from '@newStore/referenceFrames/referenceFramesState';
import { NodeType, type RootNodeConfig } from '@nodeTypeConfig/configTypes';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';
import { settings } from '../../settings';

const KRC_CURRICULUM: RootNodeConfig = {
  nodeSelector: selectKrcCurriculumNode,
  information: {
    definiteArticle: true,
    single: 'Op.stap',
    plural: 'Op.stap',
    icon: require('../../../../img/icons/zill.svg'),
    category: 'LEERPLAN',
  },
  onLoadActions: [
    getAllOfResource({ resource: pathMap.minimumGoals, refresh: false }),
    loadReferenceFrame({ referenceFrame: referenceFrames.krc }),
  ],
  websiteHref: null,
  relationsToIgnore: ['IS_VERSION_OF', 'IS_INCLUDED_IN', 'REPLACES', 'REFERENCES'],
  tocTypes: [
    NodeType.KRC_DISCIPLINE_CONTAINER,
    NodeType.KRC_CURRICULUM_DISCIPLINE,
    NodeType.KRC_CURRICULUM_DOMAIN,
    NodeType.KRC_REFERENCE_FRAME,
  ],
  createChildDefaults: [
    {
      type: ContentType.KRC_DISCIPLINE_CONTAINER,
      readorder: 1,
    },
    {
      type: ContentType.KRC_REFERENCE_FRAME,
      readorder: 2,
    },
  ],
  buildingBlocks: [],
  edit: [titleComponent],
  allowSuggestions: false,
  isCreatable: true,
  isSearchable: true,
  ...(settings.apisAndUrls.krcSelector && {
    previewModes: [
      {
        type: 'URL',
        name: 'Opstap Selector',
        location: `${settings.apisAndUrls.krcSelector}/?preview`,
      },
    ],
  }),
};

export default KRC_CURRICULUM;
